import {PurchaseTypeVo} from '../../common/shared/api/nicolas/vo/enums/PurchaseTypeVo.enum';
import {PurchaseType} from '../generated/types';

export function createPurchaseType(
  purchase_type: PurchaseTypeVo
): PurchaseType {
  return map[purchase_type];
}

const map: {[key in PurchaseTypeVo]: PurchaseType} = {
  [PurchaseTypeVo.Buy]: PurchaseType.Buy,
  [PurchaseTypeVo.NotPurchased]: PurchaseType.NotPurchased,
  [PurchaseTypeVo.Rent]: PurchaseType.Rent,
  [PurchaseTypeVo.SetBuy]: PurchaseType.SetBuy,
  [PurchaseTypeVo.SetRent]: PurchaseType.SetRent,
};
